import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const el = document.querySelector(hash);
            if (el) {
                const t = setTimeout(
                    () => el.scrollIntoView({ behavior: "smooth", block: "start" }),
                    60
                );
                return () => clearTimeout(t);
            }
        }
        window.scrollTo({ top: 0, behavior: "auto" });
    }, [pathname, hash]);
    return null;
}
